"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findClosestLocale = void 0;
const __1 = require("..");
const findClosestLocale = (requestedLocale, available, fallback) => {
    if (available.includes(requestedLocale)) {
        return requestedLocale;
    }
    const foundTranslation = available.find(it => {
        return (0, __1.twoCharacterCode)(it) === (0, __1.twoCharacterCode)(requestedLocale);
    });
    if (foundTranslation) {
        return foundTranslation;
    }
    return fallback;
};
exports.findClosestLocale = findClosestLocale;
